import { css } from "@emotion/react";
import { theme } from "@minted/minted-components";

/**
 * Typography reset to undo the site's FancyClothes/theme overrides (letter-spacing,
 * line-height, color, text-transform) so content renders with design-system defaults.
 * Spread into the relevant wrapper at call sites (modals, cards, RSVP forms, etc.).
 *
 * Use `text-transform: none` here, not `unset`: `text-transform` is inherited, and
 * `unset` on inherited properties behaves like `inherit`, so the body theme would still apply.
 */
export const themeTypographyResetStyles = css`
  color: ${theme.colors.textPrimary};
  letter-spacing: normal;
  line-height: normal;
  text-transform: none;
`;
